module.exports = __webpack_public_path__ + "static/media/dragonpay.9243795a.png";